import {Component, Inject, ViewChild} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {HttpService, SnackbarService} from '../../core';
import { environment as env } from '../../../environments/environment';
import { GeneralService } from '../../core';
import { SettingsProvider } from '../../core';
import {ProductsDataService} from '../../domain/products/services/products.data.service';
import {Observable} from 'rxjs';
import {PriceContract} from '../../domain/products/product-page/price-contracts/price-contracts.component';
import * as _moment from 'moment';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter} from '@angular/material-moment-adapter';
import {FormControl, FormGroup} from '@angular/forms';


const moment = _moment;

export const MY_FORMATS = {
    parse: {
        dateInput: 'YYYY-MM-DD',
    },
    display: {
        dateInput: 'YYYY-MM-DD',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY'
    },
};

export interface DialogData {
    contract: PriceContract;
}

@Component({
    selector: 'update-price-contract-dialog',
    templateUrl: 'update-price-contract-dialog.component.html',
    styleUrls: ['update-price-contract-dialog.component.scss'],
    providers: [
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
        },

        {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
    ],
})

export class UpdatePriceContractDialogComponent {
    updating = false;
    priceValue = this.data.contract.price;
    selectedContract = this.data.contract.contractType === 'Fix' ? 0 : this.data.contract.contractType === 'Min' ? 1 : 2;

    range = new FormGroup({
        start: new FormControl(moment(this.data.contract.validFrom)),
        end: new FormControl(moment(this.data.contract.validTo))
    });

    constructor(
        public snackBar: SnackbarService,
        public dialogRef: MatDialogRef<UpdatePriceContractDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData,
        public generalService: GeneralService,
        public settingsService: SettingsProvider,
        public dataService: ProductsDataService,
        private http: HttpService,
    ) {}

    close(): void {
        this.dialogRef.close();
    }

    onNoClick(): void {
        this.dialogRef.close({ confirm: false });
    }

    confirmFromDialog(): void {
        this.dialogRef.close({ confirm: true });
    }

    selectedContractChange(event): void {
        this.selectedContract = event.value;
    }

    priceOnBlur(event): void {
        if (event.target.value < 0) {
            event.target.value = 0.01;
        }
        this.priceValue = Number(parseFloat(event.target.value).toFixed(2));
    }

    dateToRequestData(date: Date): string {
        return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}T12:00:00`;
    }

    updatePriceContract(): Observable<any> {
        const url = `${this.settingsService.configuration.url}${env.PriceContractDataService.apiUrlUpdate}`;
        const data = {
            priceContractId: this.data.contract.id,
            contractType: this.selectedContract,
            validFrom: this.dateToRequestData(this.range.controls.start.value.toDate()),
            validTo: this.dateToRequestData(this.range.controls.end.value.toDate()),
            price: this.priceValue
        };
        return this.http.put(url, data);
    }

    updatePriceContractClick(): void {
        if (!this.range.controls.start.hasError('matStartDateInvalid') && !this.range.controls.end.hasError('matEndDateInvalid')) {
            this.updating = true;
            this.updatePriceContract().subscribe(
                () => {
                    this.dialogRef.close({confirm: true});
                    this.snackBar.info('Udało się zaktualizować kontrakt cenowy');
                },
                logErr => {
                    if (logErr.status === 400) {
                        this.snackBar.info('Podany okres obowiązywania nachodzi na okres obowiązywania innego kontraktu');
                    } else {
                        this.snackBar.info('Nie udało się zaktualizować kontraktu cenowego');
                    }
                    this.updating = false;
                },
                () => this.updating = false
            );
        }
    }
}
